<template>
  <div>
    <div class="head">
      <SecondaryTitle :align="isMobile ? 'center' : 'left'">
        <span v-t="'Refresh Password'" />
      </SecondaryTitle>
      <!-- <v-btn :to="{ name: 'register' }" class="button-link" text small> -->
      <!-- <v-btn class="button-link" text small>
        <v-icon class="icon signArrow">mdi-arrow-right</v-icon>
        <span v-t="'Create new account'" />
      </v-btn> -->
    </div>
    <!-- <social-auth btn-class="ma-1" rounded dark large @auth="afterAuthenticated" /> -->
    <!-- <base-separator v-t="'Or login with email'" /> -->

    <form ref="form" :action="formAction" :method="formMethod">
      <span v-show="false" v-html="csrfTokenInput"></span>
      <v-row class="spacing3">
        <v-col cols="12" sm="12" class="px-3">
          <!-- <v-text-field
              v-model="email"
              :label="$t('Email')"
              :rules="rules.email"
              color="secondary"
              class="input"
              name="email"
              filled
              required
            /> -->
          <v-text-field
            v-model="form.email"
            :error-messages="form.error('email')"
            :error="form.state('email')"
            :success="status === 'success'"
            :disabled="status === 'success'"
            :label="$t('Email')"
            :rules="rules.email"
            color="secondary"
            class="input"
            name="email"
            filled
            required
          />
        </v-col>
      </v-row>
      <div class="form-footer">
        <div class="btn-area">
          <v-btn
            large
            block
            color="secondary"
            @click.prevent="onSubmit"
            type="submit"
            :loading="loading"
            :disabled="status === 'success'"
          >
            <span v-t="'Send me instructions'" />
          </v-btn>
        </div>
        <v-alert class="mt-8" v-if="errorMessage" type="error">
          <span v-html="errorMessage" />
        </v-alert>
        <v-alert class="mt-8" v-if="status" :type="status">
          <span v-html="statusMessage" />
        </v-alert>
      </div>
    </form>

    <!-- <v-alert type="success" class="mt-5">
      Me saatsime parooli värskendamise lingi sinu e-posti aadressile.
      <br />
      Sa peaksid lingi kätte saama mõne minuti jooksul. Kui sa seda ei leia, siis kontrolli
      kindlasti ka rämpsposti kausta.
    </v-alert> -->
  </div>
</template>

<script>
// import SocialAuthOld from "./SocialAuthOld";
import { csrfTokenInput } from "@/landing/common/meta/csrf-token";
import routerLink from "@/landing/static/text/link";
import SecondaryTitle from "../MainTitle/SecondaryTitle";
// import SocialAuth from "@/_shared/components/auth/SocialAuth";
import Form from "@/landing/common/form";
import validationMixin from "@/landing/mixins/validationMixin";

export default {
  mixins: [validationMixin],
  components: {
    // SocialAuth,
    SecondaryTitle,
    // SocialAuthOld,
  },
  props: {
    formAction: {
      type: String,
      default: null,
    },
    formMethod: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      csrfTokenInput,
      routerLink: routerLink,
      form: new Form({
        email: "",
        password: "",
        remember: false,
      }),
      checkbox: false,
      //   valid: true,
      //   email: "",
      //   password: "",
      loading: false,
      showPassword: false,
      errorMessage: null,
      status: null,
      statusMessage: null,
    };
  },
  methods: {
    onSubmit() {
      //   if (this.$refs.form.validate()) {
      //     console.log("data submited");
      //   }
      this.submit();
    },
    afterAuthenticated(response) {
      this.$store.dispatch("fetchAll");
      if (this._.get(response, ["data", "intended"], null)) {
        return window.location.replace(response.data.intended);
      }
      this.$router.push({ name: "home" });
    },
    submit() {
      this.loading = true;
      this.clearMessages();

      /* eslint-disable no-unused-vars */
      //   this.axios.get("/sanctum/csrf-cookie").then(() => {
      this.form
        .post("global/auth/reset", "/")
        .then((response) => {
          this.$emit("change");
          this.status = response.data.status;
          this.statusMessage = response.data.message;
          this.loading = false;
          //   this.afterAuthenticated(response);
        })
        .catch((error) => {
          this.errorMessage = this._.get(
            error,
            ["response", "data", "message"],
            this._.get(error, "message", null),
          );
          this.loading = false;
        });
      //   });
    },
    clearMessages() {
      this.errorMessage = null;
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;

      //   const smDown = this.$store.state.breakpoints.smDown
      //   return smDown.indexOf(this.$mq) > -1
    },
  },
};
</script>
